export default __webpack_public_path__ + "static/tm-a25a413fe06310f7bb591b5b6d167200.svg";